import { InjectionToken } from '@angular/core';

import { parseUrl } from './parse-url';

export const PRIZE_LINK_HOSTS = new InjectionToken<readonly string[]>('PRIZE_LINK_HOSTS');

export function isAllowedPrizeLink(url: string, hosts: readonly string[]): boolean {
  const parsed = parseUrl(url);
  return parsed !== null && parsed.protocol === 'https:' && hosts.includes(parsed.hostname);
}
